import {login, logout, getUserInfo} from '@/api/user'
import {setToken, getToken, setAgentId, getAgentId,setLocalCookies,getLocalCookies} from '@/utils/util'

export default {
    state: {
        userName: '',
        userId: '',
        nickName: '',
        avatarImgPath: '',
        token: getToken(),
        agentId: getAgentId(),
        isQuarterManageRole: getLocalCookies('isQuarterManageRole') == 'true'? true : false,//小区管理员
        isMaintenance: getLocalCookies('isMaintenanceRole') == 'true'? true : false,//运维人员
        isSupplierRole: getLocalCookies('isSupplierRole') == 'true'? true : false,//
        isStockManagerRole:getLocalCookies('isStockManagerRole') == 'true'? true : false,//仓储
        isDriverRole:getLocalCookies('isDriverRole') == 'true'? true : false,//司机
        isAdministorRole:getLocalCookies('isAdministorRole') == 'true'? true : false,//超级管理员
        isOutSupplierRole:getLocalCookies('isOutSupplierRole') == 'true'? true : false,//外部补货操作员
        hasGetInfo: false,
        mobile: '',
        email: '',
        accountId:'',
        shopId:'',
        userRoleList: [],
    },
    mutations: {
        setAvatar(state, avatarPath) {
            state.avatarImgPath = avatarPath
        },
        setNickName(state, nickName) {
            state.nickName = nickName
        },
        setUserId(state, id) {
            state.userId = id
        },
        setAccountId(state, id) {
            state.accountId = id
        },
        setUserName(state, name) {
            state.userName = name
        },
        setToken(state, {token, auto}) {
            state.token = token
            setToken(token, auto)
        },
        setHasGetInfo(state, status) {
            state.hasGetInfo = status
        },
        setMobile(state, mobile) {
            state.mobile = mobile
        },
        setEmail(state, email) {
            state.email = email
        },
        setShopId(state, shopId) {
            state.shopId = shopId;
        },
        setAgentId(state, {agentId, auto}) {
            state.agentId = agentId
            setAgentId(agentId, auto)
        },
        setQuarterManageRole(state, bol){
            state.isQuarterManageRole = bol;
            setLocalCookies('isQuarterManageRole',bol)
        },
        setMaintenanceRole(state, bol){
            state.isMaintenanceRole = bol;
            setLocalCookies('isMaintenanceRole',bol)
        },
        setSupplierRole(state, bol){
            state.isSupplierRole = bol;
            setLocalCookies('isSupplierRole',bol)
        },
        setCabinetToolSupplyRole(state, bol){
            state.isCabinetToolSupplyRole = bol;
        },
        setCabinetToolBuyerRole(state, bol){
            state.isCabinetToolBuyerRole = bol;
        },
        setStockManagerRole(state,bol){
            state.isStockManagerRole = bol;
            setLocalCookies('isStockManagerRole',bol)
        },
        setDiverRole(state,bol){
            state.isDriverRole = bol;
            setLocalCookies('isDriverRole',bol)
        },
        setAdminRole(state,bol){
            state.isAdministorRole = bol;
            setLocalCookies('isAdministorRole',bol)
        },
        setOutSupplierRole(state,bol){
            state.isOutSupplierRole = bol;
            setLocalCookies('isOutSupplierRole',bol)
        },
        setRoleList(state, list){
            state.userRoleList = list;
        },
    },
    actions: {
        // 登录
        handleLogin({commit}, {username, password,aliasName, auto}) {
            username = username.trim()
            return new Promise((resolve, reject) => {
                login({
                    username,
                    password,
                    aliasName
                }).then(res => {
                    console.log(res);
                    if (res.code === 0) {
                        let token = res.data.access_token
                        commit('setToken', {token, auto})
                        resolve()
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 退出登录
        handleLogout({state, commit}) {
            return new Promise((resolve, reject) => {
                logout().then(res => {
                    commit('setToken', '')
                    commit('setHasGetInfo', false)
                    commit('setQuarterManageRole', false)
                    commit('setMaintenanceRole', false)
                    commit('setSupplierRole', false)
                    commit('setStockManagerRole', false)
                    commit('setDiverRole', false)

                    commit('setOutSupplierRole', false)
                    commit('setAdminRole', false)
                    commit('setSupplierRole', false)
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取用户相关信息
        getUserInfo({state, commit}) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(res => {
                    if (res.code === 0) {
                        commit('setAvatar', res.data.avatar)
                        commit('setUserName', res.data.username)
                        commit('setNickName', res.data.nickName)
                        commit('setUserId', res.data.userId)
                        commit('setAccountId', res.data.accountId)
                        commit('setEmail', res.data.attrs.email)
                        commit('setMobile', res.data.attrs.mobile)
                        if(res.data.shopId){
                            commit('setShopId', res.data.shopId)
                        }
                        let agentId = res.data.attrs.agentId;
                        let bol = true;
                        commit('setAgentId', {agentId, bol})
                        commit('setHasGetInfo', true)
                        let quarterManageRole = false;
                        let maintenanceRole = false;
                        let supplierRole = false;
                        let cabinetToolSupplyRole = false;
                        let cabinetToolBuyerRole = false;
                        let stockManagerRole = false;
                        let driverRole = false;
                        let administratorRole = false;
                        let outSupplierRole = false;
                        if(res.data.roles.length != 0){
                            res.data.roles.forEach(role=>{
                                if(role.roleName == '小区管理员'){
                                    quarterManageRole = true;
                                }
                                if(role.roleName == '维护管理员'){
                                    maintenanceRole = true;
                                }
                                if(role.roleName == '补货员' || role.roleName == '补货人员'){
                                    supplierRole = true;
                                }
                                if(role.roleName == '外部补货操作员'){
                                    outSupplierRole = true;
                                }

                                if(role.roleName == '工具箱-采购管理员'){
                                    cabinetToolBuyerRole = true;
                                }
                                if(role.roleName == '工具箱-供货管理员'){
                                    cabinetToolSupplyRole = true;
                                }
                                if(role.roleName == '仓库管理员'){
                                    stockManagerRole = true;
                                }
                                if(role.roleName == '系统管理员'){
                                    administratorRole = true;
                                }

                                if(role.roleName == '司机' || role.roleName == '司机人员' ){
                                    driverRole = true;
                                }

                            })
                        }
                        // if(getLocalCookies('isQuarterManageRole') == 'false' && getLocalCookies('isSupplierRole') == 'false'){
                        //
                        // }
                        commit('setQuarterManageRole', quarterManageRole)
                        commit('setSupplierRole', supplierRole)
                        commit('setOutSupplierRole', outSupplierRole)

                        commit('setMaintenanceRole', maintenanceRole)
                        commit('setCabinetToolBuyerRole', cabinetToolBuyerRole)
                        commit('setCabinetToolSupplyRole', cabinetToolSupplyRole)
                        commit('setStockManagerRole', stockManagerRole)
                        commit('setDiverRole', driverRole)
                        commit('setAdminRole', administratorRole)
                        commit('setRoleList',res.data.roles || [])
                        resolve(state)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        //设置token
        setToken({commit}, {token, auto}) {
            commit('setToken', {token, auto})
        },
        //设置agentId
        setAgentId({commit}, {agentId, auto}) {
            commit('setAgentId', {agentId, auto})
        },
        setStockManagerRole({commit}, bol){
            commit('setStockManagerRole', bol)
        },
        //设置QuarterManageRole
        setQuarterManageRole({commit}, bol) {
            commit('setQuarterManageRole', bol)
        },
        setSupplierRole({commit},bol) {
            commit('setSupplierRole', bol)
        },
        setDiverRole({commit},bol) {
            commit('setDiverRole', bol)
        },
        setAdminRole({commit},bol) {
            commit('setAdminRole', bol)
        },

    }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js